import { createContext, useContext, useMemo } from 'react';
import { useAuth } from '../hooks/useAuth.js';

// Create the context object.
// We initialize it with `null` because the provider will set the actual value.
const AuthContext = createContext(null);

// Custom hook to access the authentication context easily.
// This is a convenient way to get the auth data without importing `AuthContext`
// and calling `useContext` everywhere.
export const useAuthContext = () => useContext(AuthContext);

// The provider component wraps your app and provides the authentication state.
// This is where we call the `useAuth` hook to get the state and functions.
export const AuthProvider = ({ children }) => {
    const authData = useAuth();
    
    // We use `useMemo` to prevent unnecessary re-renders of child components
    // if the `authData` object itself doesn't change.
    const contextValue = useMemo(() => authData, [authData]);

    return (
        <AuthContext.Provider value={contextValue}>
            {children}
        </AuthContext.Provider>
    );
};
